export default "__VITE_ASSET__ro8Jf6BP__"